import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "delete-project-confirm__title" }
const _hoisted_2 = { class: "delete-project-confirm__actions" }

import { ref } from "vue";
import AppButton from "@/components/ui-kit/button/AppButton.vue";
import { useConfirmKeys } from "@/composables/useConfirmKeys";


export default /*@__PURE__*/_defineComponent({
  __name: 'DeleteProjectConfirmDropdown',
  props: {
    loading: { type: Boolean }
  },
  emits: ["cancel", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const $root = ref<HTMLElement | null>(null)

useConfirmKeys({
	content: $root,
	cancel: () => emit('cancel'),
	confirm: () => emit('confirm'),
	disabled: () => !!props.loading,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "$root",
    ref: $root,
    class: "delete-project-confirm"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('project_delete_question')), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppButton, {
        class: "delete-project-confirm__actions-button",
        type: "secondary",
        label: _ctx.$t('cancel_short'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, null, 8, ["label"]),
      _createVNode(AppButton, {
        class: "delete-project-confirm__actions-button",
        label: _ctx.$t('remove'),
        disabled: props.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('confirm')))
      }, null, 8, ["label", "disabled"])
    ])
  ], 512))
}
}

})